window._ = require('lodash');
window.Swal = require('sweetalert2');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

// try {
//     window.Popper = require('popper.js').default;
//     window.$ = window.jQuery = require('jquery');

//     require('bootstrap');
// } catch (e) {
//     console.warn(e)
// }

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

const defaultHeaders = {
    'Accept': 'application/json',
    'platform-type': 'web',
    'X-Requested-With': 'XMLHttpRequest',
    // 'app-version': process.env.VUE_APP_VERSION,
    // 'app-name': process.env.APP_NAME
}
window.axios.defaults.headers.common = defaultHeaders;

window.axios.interceptors.response.use(function (response) {
    // Do something with response data
    const data = response && response.data ? response.data : {}

    return data
}, function (error) {
    if (process.env.MIX_APP_ENV !== 'local') {
        if (error.response.status === 403) {
            window.location.href = "/report/dashboard";
        }

        if (error.response.status === 401) {
            window.location.href = "/";
        }

        if (error.response.status === 404) {
            // window.location.href = "/error/404";
        }

        if (error.response.status === 500) {
            // window.location.href = "/error/500";
        }

        if (error.response.status === 504) {
            // window.location.href = "/error/500";
        }
    }

    return Promise.reject(error);
    // Do something with response error
});

window.axios.interceptors.request.use(function (config) {
    // Do something before request is sent
    return config;

}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     encrypted: true
// });
